import { render, staticRenderFns } from "./AIAgent.vue?vue&type=template&id=af5e4d34&scoped=true"
import script from "./AIAgent.vue?vue&type=script&lang=js"
export * from "./AIAgent.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.vue?vue&type=style&index=0&id=af5e4d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e4d34",
  null
  
)

export default component.exports